import React, { useState, useEffect } from "react";
import { Menu, X, Code2 } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  return (
    <header
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-lg" : "bg-white/95 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center space-x-1">
            <img
              src="/src/assets/logoModelos2.png"
              alt="ModeloSmart Logo"
              style={{ height: "120px", width: "auto" }}
            />
          </div>

          {/* Navigation - Desktop */}
          <nav className="hidden md:flex space-x-6">
            <button
              onClick={() => scrollToSection("inicio")}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection("servicios")}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection("experiencia")}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Experiencia
            </button>
            <button
              onClick={() => scrollToSection("tecnologias")}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Tecnologías
            </button>
            <button
              onClick={() => scrollToSection("contacto")}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Contacto
            </button>
          </nav>

          {/* CTA Button - Desktop */}
          <button
            onClick={() => scrollToSection("contacto")}
            className="hidden md:inline-flex items-center px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            Solicita tu cotización
          </button>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection("inicio")}
                className="text-left py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
              >
                Inicio
              </button>
              <button
                onClick={() => scrollToSection("servicios")}
                className="text-left py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
              >
                Servicios
              </button>
              <button
                onClick={() => scrollToSection("experiencia")}
                className="text-left py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
              >
                Experiencia
              </button>
              <button
                onClick={() => scrollToSection("tecnologias")}
                className="text-left py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
              >
                Tecnologías
              </button>
              <button
                onClick={() => scrollToSection("contacto")}
                className="text-left py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
              >
                Contacto
              </button>
              <button
                onClick={() => scrollToSection("contacto")}
                className="mt-4 px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200 text-center"
              >
                Solicita tu cotización
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
